/*

Sainapse® incorporates patented, and “patent pending”, technology.

© 2017 - 2024 Sainapse Inc. and its licensors. All rights reserved worldwide.

Sainapse Inc. and its licensors own all rights in this work, including but not limited to the source code, algorithms, text, 
flowcharts and images herein, which are protected by copyright laws in applicable jurisdictions. Any use of this work is permissible 
only with an express written license or authorization from Sainapse Inc., and only to the extent and for the purpose permitted. 
Unauthorized copying, editing, reproduction, redistribution, modification, creation of derivative works, translation, adaptation, 
customization, decompilation, reverse engineering, disassembling or hacking of this work or any part thereof, including but not limited to the source code, 
header files and libraries of the software, via any medium is strictly prohibited.

Open Source Software that is provided as part of Sainapse® is subject to and governed solely by the terms and conditions of the applicable open source license agreements, 
and their respective terms, conditions, restrictions and obligations, a copy of which will be made available to you upon request.

Proprietary and Confidential. Sainapse® and associated documentation is the property of Sainapse Inc. and considered confidential information. 
No part of it may be disclosed without the express written consent of Sainapse Inc.Please note that any infringement or violation will invite legal action, 
both civil and criminal, as appropriate, without any further notice.

*/
import initialState from "../initialState";

const clone = require("rfdc")();

export default function rootReducer(state = initialState, action) {
  console.log("root reducer", action);
  switch (action.type) {
    case "UPDATE_STATE":
      return update_state(state, action.payload);
    case "UPDATE_AUTH_TOKEN":
      console.log("update auth token", action);
      return { ...state, auth_token: action.payload };
    case "UPDATE_LOGGED_IN_USER_INFO":
      return { ...state, logged_in_user_info: action.payload };
    // case "UPDATE_AUTHENTICATION_STATUS":
    //   console.log("update auth status", action);
    //   return { ...state, isAuthenticated: action.payload };
    // case "UPDATE_AUTHENTICATED_IN_USER_INFO":
    //   return { ...state, authenticatedUserInfo: action.payload };
    case "CHANGE_SCREEN":
      return change_screen(state);

    default:
      return state;
  }
}

let update_state = (cur_state, payload) => {
  let new_state = clone(cur_state);
  console.log("Cur State and New State : ", new_state === cur_state);
  console.log("Payload: ", payload);
  let new_obj = {
    [payload.type]: payload.data,
  };
  new_state[payload.comp_id] = { ...new_state[payload.comp_id], ...new_obj };
  console.log("New State :", new_state);

  return new_state;
};

let change_screen = (cur_state) => {
  let new_state = clone(cur_state);
  new_state.screen_state = "";

  return new_state;
};
